import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { toast } from "sonner";
import AuthLayout, { Field, SubmitButton } from "@/pages/AuthLayout";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name.split(" ")[0]}`);
      if (user.role === "patient" && !user.email_verified) navigate("/verify");
      else navigate(`/${user.role}`);
    } catch (e2) {
      setError(apiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Sign in" subtitle="Access your ManoGene clinical workspace.">
      <form onSubmit={submit} data-testid="login-form">
        <Field label="Email" type="email" required value={email}
          onChange={(e) => setEmail(e.target.value)} data-testid="login-email" placeholder="you@example.com" />
        <Field label="Password" type="password" required value={password}
          onChange={(e) => setPassword(e.target.value)} data-testid="login-password" placeholder="••••••••" />
        {error && <p className="text-sm text-red-600 mb-3" data-testid="login-error">{error}</p>}
        <SubmitButton loading={loading} type="submit" data-testid="login-submit">Sign in</SubmitButton>
      </form>
      <div className="flex justify-between mt-4 text-sm">
        <Link to="/forgot-password" className="text-brand font-medium hover:underline">Forgot password?</Link>
        <Link to="/register" data-testid="login-register-link" className="text-ink-soft hover:text-brand">Create account</Link>
      </div>
      <div className="mt-8 rounded-lg bg-slate-50 border border-slate-200 p-3 text-xs text-ink-soft">
        <div className="font-semibold text-ink mb-1">Demo accounts</div>
        <div className="mono">patient@manogene.com · Patient@123</div>
        <div className="mono">clinician@manogene.com · Clinician@123</div>
        <div className="mono">lab@manogene.com · Lab@123</div>
      </div>
    </AuthLayout>
  );
}
